import { OptionsDictionary } from '~src/ts/models/sort/SortOptionDefinitions';

export const userIdentityConflictSortOptions: OptionsDictionary = {
};
